import type { DocsFacade } from '../state/docs/docs.facade';
import type { TicketsFacade } from '../state/tickets/tickets.facade';
import { inferRepoRoleFromRepoRef, type RepoRole } from './repo-role.util';

export async function loadReposSettings(docs: DocsFacade, projectId: string): Promise<any | null> {
  if (!projectId) return null;
  try {
    await docs.loadProjectDocs(projectId);
  } catch {}

  let settingsDoc = docs.byProjectAndKey(projectId, 'repos.settings')();
  const keys = settingsDoc?.data && typeof settingsDoc.data === 'object' ? Object.keys(settingsDoc.data).length : 0;
  if (!settingsDoc || keys === 0) {
    try {
      settingsDoc = await docs.loadOne(projectId, 'repos.settings');
    } catch {
      settingsDoc = null;
    }
  }
  return settingsDoc?.data ?? null;
}

export function buildReposPayload(settings: any): Array<{ owner: string; repo: string; role?: RepoRole }> {
  return Array.isArray(settings?.github?.repos)
    ? settings.github.repos
        .map((repo: any) => ({
          owner: String(repo?.owner ?? '').trim(),
          repo: String(repo?.name ?? '').trim(),
          role: inferRepoRoleFromRepoRef(repo),
        }))
        .filter((repo: any) => repo.owner && repo.repo)
    : [];
}

export function buildTicketsProjectContext(
  ticketsStore: TicketsFacade,
  settings?: any,
): { definition?: any; schema?: any; diagram?: any; repos?: any } {
  return {
    definition: ticketsStore.projectDefinition(),
    schema: ticketsStore.projectSchema(),
    diagram: ticketsStore.projectDiagram(),
    repos: settings ?? null,
  };
}
